import { Typographies } from '@/theme';
import { Typography, styled } from '@mui/material';

export const UploadWidgetStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  background: theme.palette.white.dark,
  color: theme.palette.dark.dark_4,
  borderRadius: theme.spacing(1),
  height: 150,
  width: 150,
  cursor: 'pointer',
  overflow: 'hidden',
  '& img': { maxWidth: '100%', height: 'auto' },
}));

export const VideoPlayerStyled = styled('video')(({ theme }) => ({
  borderRadius: theme.spacing(1),
  height: 300,
}));

export const DeleteImageTextStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  cursor: 'pointer',
  textAlign: 'center',
}));
export const InfoImageTextStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.dark.dark_4,
  textAlign: 'center',
  fontSize: Typographies.FONT_SIZE_INPUTS,
}));
export const ContainerStyled = styled(Typography)(({ theme }) => ({
  height: 150,
  width: 150,
}));
